import type { II18nRepository } from '../repositories/i18n.repository'
import type { LocaleMessages } from '../repositories/i18n.repository'

export const DEFAULT_LOCALE = 'hy'

export const SUPPORTED_LOCALES = ['hy', 'ro', 'ru', 'en'] as const
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

export class I18nService {
  private static instance: I18nService | null = null

  constructor(private readonly i18nRepository: II18nRepository) {}

  static getInstance(i18nRepository: II18nRepository): I18nService {
    if (!I18nService.instance) {
      I18nService.instance = new I18nService(i18nRepository)
    }
    return I18nService.instance
  }

  static resetInstance(): void {
    I18nService.instance = null
  }

  getDefaultLocale(): string {
    return DEFAULT_LOCALE
  }

  getSupportedLocales(): readonly string[] {
    return SUPPORTED_LOCALES
  }

  async loadDefaultLocale(): Promise<LocaleMessages> {
    return this.i18nRepository.loadMessages(DEFAULT_LOCALE)
  }

  async loadLocale(locale: string): Promise<LocaleMessages> {
    return this.i18nRepository.loadMessages(locale)
  }
}
